import { schema } from 'normalizr';
import videoLink from 'reducers/schemas/videoLink';

export default new schema.Entity('videoChannels', {
    video_links: [videoLink],
});
